import Vue from '../../../node_modules/vue/dist/vue.esm.browser';
import vuejsDatepicker from 'vuejs-datepicker';
// import Axios from 'axios';

globalThis.Vue = Vue;
globalThis.vuejsDatepicker = vuejsDatepicker;
// globalThis.Axios = Axios;
// globalThis.axios = Axios;
